var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.6357 48.1886L49.1429 47.0588L78.5857 74.8069L74.4433 78.9509L46.6952 49.508L47.825 90H42.0489L43.1796 49.508L15.4306 78.9509L11.2874 74.8069L40.7303 47.0596L0.238281 48.1886V42.4133L40.7303 43.732L11.2874 15.9204L15.4306 11.8398L43.1796 41.2835L42.0489 0.791504H47.825L46.6952 41.2835L74.4425 11.8406L78.5865 15.9204L49.1429 43.732L89.6348 42.6013L89.6357 48.1886Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1d15c733e442f12c027046994fcc4508.svg";
export { ForwardRef as ReactComponent };